import React from 'react'

const Checkbox = ({ value, className, textLabel, name, onChange, checked, id,isLabelSpan = false }) => {
  return (
    <div className={`checkbox ${className}`}>
      <input value={value} type="checkbox" checked={checked} name={name} id={id} onChange={onChange} />
      {isLabelSpan ? <span>{textLabel}</span> : <label className='body-s'>{textLabel}</label>}
    </div>
  )
}

export default Checkbox